import { FilterState } from '@/app/(main)/(pages)/busca/[slug]/_types/filter-state.type';
import { SearchFilterAgeGroupType } from '@/app/(main)/(pages)/busca/[slug]/_types/search-filter-age-group.type';
import { SearchFilterDayTimeType } from '@/app/(main)/(pages)/busca/[slug]/_types/search-filter-day-time.type';
import { SearchSortType } from '@/app/(main)/(pages)/busca/[slug]/_types/search-sort.type';
import { SearchFilterProfessionalGenderType } from '@/app/(main)/(pages)/busca/[slug]/_types/search-filter-professional-gender.type';

export const initialFilterState: FilterState = {
  dayTime: SearchFilterDayTimeType.ALL,
  professionalGender: SearchFilterProfessionalGenderType.ALL,
  orderBy: SearchSortType.RELEVANCE,
  distance: 10,
  minDate: undefined,
  maxDate: undefined,
  followUp: false,
  onlyScheduled: false,
  ageGroup: SearchFilterAgeGroupType.ALL,
};
